import React, { useContext } from "react";
import { Card, Badge, Button } from "react-bootstrap";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ScheduleIcon from "@mui/icons-material/Schedule";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CancelIcon from "@mui/icons-material/Cancel";
import { CurrencyContext } from "../Contexts/CurrencyContext";

const statusConfig = {
  paid: { icon: CheckCircleIcon, label: "Paid", variant: "success" },
  pending: { icon: ScheduleIcon, label: "Pending", variant: "secondary" },
  overdue: { icon: WarningAmberIcon, label: "Overdue", variant: "danger" },
  cancelled: { icon: CancelIcon, label: "Cancelled", variant: "dark" },
};

export default function PaymentTimeline({ stages, onRecordPayment, requireReceipt, formatCurrency: formatCurrencyProp }) {
  const { formatCurrency: formatCurrencyContext } = useContext(CurrencyContext);
  const formatCurrency = formatCurrencyProp ?? formatCurrencyContext ?? ((v) => (v != null ? `Rs. ${Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "-"));
  return (
    <div className="payment-timeline">
      {stages.map((stage, index) => {
        const config = statusConfig[stage.status] || statusConfig.pending;
        const Icon = config.icon;
        const remaining = stage.remaining ?? (Number(stage.amount) - Number(stage.paid_amount || 0));
        const canPay = remaining > 0 && stage.status !== "cancelled";

        return (
          <Card key={stage.id} className="mb-3 shadow-sm">
            <Card.Body className="d-flex flex-wrap align-items-center justify-content-between gap-2">
              <div className="d-flex align-items-center gap-2 flex-grow-1">
                <Icon
                  fontSize="medium"
                  color={stage.status === "paid" ? "success" : stage.status === "overdue" ? "error" : "action"}
                />
                <div>
                  <Card.Title className="mb-0 small">
                    Stage {stage.stage_number}
                    <Badge bg={config.variant} className="ms-2">
                      {config.label}
                    </Badge>
                  </Card.Title>
                  <Card.Text className="text-muted small mb-0">
                    Due: {stage.due_date} · Amount: {formatCurrency(stage.amount)}
                    {stage.paid_amount != null && stage.paid_amount > 0 && (
                      <> · Paid: {formatCurrency(stage.paid_amount)}</>
                    )}
                    {canPay && (
                      <> · Remaining: {formatCurrency(remaining)}</>
                    )}
                  </Card.Text>
                  {stage.transactions?.length > 0 && (
                    <ul className="small text-muted mt-1 mb-0 ps-3">
                      {stage.transactions.map((t) => (
                      <li key={t.id}>
                        {formatCurrency(t.amount)} ({t.payment_method}) – {t.created_at?.slice(0, 10)}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              {canPay && onRecordPayment && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => onRecordPayment(stage)}
                >
                  Record Payment
                </Button>
              )}
            </Card.Body>
          </Card>
        );
      })}
    </div>
  );
}
